
(function () {
    if (document.querySelectorAll(".js-anchor-link-page").length > 0) {

        const anchorLinkPage = {
            init: function () {
                const anchors = document.querySelectorAll('.js-anchor-section');
                const anchorsArr = [...anchors];
                const links = document.querySelectorAll('.js-mainlinks-container li');

                window.addEventListener('scroll', () => {
                    if (typeof (anchors) != 'undefined' && anchors != null && typeof (links) != 'undefined' && links != null) {
                        anchorsArr.forEach((anchor, i) => {
                            const x = anchor.getBoundingClientRect();

                            if (x.top >= 0 && x.top <= 200 ) {
                                links.forEach((link) => {
                                    link.classList.remove("is-active");
                                });

                                links[i].classList.add('is-active');
                            }
                        })
                    }
                });

                const mainLinksContainer = document.querySelector(
                    ".js-mainlinks-container"
                );

                const breadcrumbsEl = document.querySelector(".js-mainlinks-wrapper");
                const scroll = document.getElementById("anchor-scroll");
                const btnScrollBackward = document.getElementById("anchor-left");
                const btnScrollForward = document.getElementById("anchor-right");

                anchorLinkPage.checkScrollBarPosition();

                if (mainLinksContainer !== null) {
                    if (mainLinksContainer.scrollWidth > mainLinksContainer.clientWidth) {
                        breadcrumbsEl.classList.add("overflowing");
                    }

                    btnScrollBackward.addEventListener("click", () => {
                        scroll.scrollLeft = scroll.scrollLeft - 200;
                        anchorLinkPage.checkScrollBarPosition();
                    });

                    btnScrollForward.addEventListener("click", () => {
                        scroll.scrollLeft = scroll.scrollLeft + 200;
                        anchorLinkPage.checkScrollBarPosition();
                    });
                }
            },
            fixNavBar: () => {
                const articleContent = document.querySelector(".js-article");
                const articleContentTop = articleContent.getBoundingClientRect().top;
                const articleContentBottom = articleContent.getBoundingClientRect().bottom;
                const header = document.querySelector(".js-header");
                const mainLinksWrapper = document.querySelector(".js-mainlinks-wrapper");

                document.addEventListener("scroll", () => {
                    if (
                        window.pageYOffset > articleContentTop &&
                        window.pageYOffset < articleContentBottom
                    ) {
                        mainLinksWrapper.classList.add("is-fixed");

                        if (header.style.top === "0px") {
                            mainLinksWrapper.style.top = "48px";
                        } else {
                            mainLinksWrapper.style.top = "0px";
                        }
                    } else {
                        mainLinksWrapper.classList.remove("is-fixed");
                        mainLinksWrapper.style.top = "";
                    }
                });
            },
            checkScrollBarPosition: () => {
                const scroll = document.getElementById("anchor-scroll");
                const btnScrollBackward = document.getElementById("anchor-left");
                const btnScrollForward = document.getElementById("anchor-right");

                if (scroll !== null) {
                    if (scroll.scrollLeft >= scroll.scrollWidth - scroll.offsetWidth) {
                        btnScrollBackward.disabled = false;
                        btnScrollForward.disabled = true;
                    }

                    if (
                        scroll.scrollLeft > 0 &&
                        scroll.scrollLeft < scroll.scrollWidth - scroll.offsetWidth
                    ) {
                        btnScrollBackward.disabled = false;
                        btnScrollForward.disabled = false;
                    }

                    if (scroll.scrollLeft === 0) {
                        btnScrollBackward.disabled = true;
                        btnScrollForward.disabled = false;
                    }
                }
            },
        };

        anchorLinkPage.init();
    }
})();
